<template>
  <v-card>
    <v-card-title>
      <v-row style="height: fit-content;" class="align-center d-flex flex-row" no-gutters>
        <v-col :lg="3">
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Search"
            single-line
            hide-details
            outlined
            dense
            @input="handleInput"
          ></v-text-field>
        </v-col>
        <v-btn v-if="entity_name == 'user'" text color="transparent">
          <div style="color: #808080;">DISPLAYING・</div>
          <div style="color: #4A4A4A;">{{ paginatedList.length }} / {{ items.length }} </div>
          <div style="color: #808080;">・TOTAL</div>
        </v-btn>
        <v-col class="d-flex flex-row-reverse">
          <v-btn v-if="hideAddButton !== true && hideAddButton != ''" depressed dark color="green" @click="$emit('add')">
            <v-icon left dark>mdi-plus</v-icon>
            Add New
          </v-btn>
          <v-btn text depressed color="green" class="mr-2" :disabled="loading" @click="$emit('reload')">
            <v-icon left dark>mdi-refresh</v-icon>
            {{reloadText}}
          </v-btn>
          <v-btn text depressed color="green" class="mr-2" :disabled="clearClicked" @click="ClearAllClicked()"
            v-if="(show_clear !== undefined && show_clear === true && entity_name !== undefined && entity_name !== '' && items.length>0)">
            Clear All
          </v-btn>
          <v-btn icon depressed color="green" class="" :disabled="printClicked" @click="GeneratePDFFile()"
            v-if="(show_print !== undefined && show_print === true)">
            <v-icon color="black" dark>print</v-icon>
          </v-btn>
          <v-btn icon depressed color="green" class="" :disabled="excelClicked" @click="GenerateExcelFile()"
           v-if="(show_excel !== undefined && show_excel === true)">
           <v-icon color="black" dark>mdi-file-excel-outline</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-card-title>
    <v-data-table id="table"
       v-bind:style="(entity_name === 'user' && showCardView == true)? 'display:none;' : 'display:block;'"
      :headers="headers"
      :items="items"
      :search="search"
      :loading="loading"
      :entity_name="entity_name"
      :show_excel="show_excel"
      :show_print="show_print"
      :show_clear="show_clear"
      :title="title"
      multi-sort
      @click:row="row => $emit('rowClick', row)"
    >
      <template v-for="(field,i) in headers" v-slot:[getFieldName(field)]="{ item }">
        <div :key="i">
          <slot :name="getFieldName(field)" v-bind:item="item">
            {{ item[field.value] }}
          </slot>
        </div>
      </template>
    </v-data-table>

  <v-container class="pa-6" v-if="(entity_name === 'user' && showCardView == true)">
  <v-row  class="row row-cols-1 row-cols-md-2 row-cols-lg-3 row-cols-xl-4 gap-4 justify-content-start justify-sm-center" style="gap: 20px; width: 100%;" no-gutters>
    <v-card class="generic-card col" style="max-width: 400px;" v-for="(item, i) in paginatedList" v-bind:data="item" v-bind:key="item.id" @click="$emit('rowClick', item)">
      <template>
        <div style="padding-top:12px;padding-left:12px;padding-right:12px">
          <div dark style="color:green" color="green lighten-2" v-if="item.id == user.id">
            <v-icon color=green class="mr-2">mdi-account-check</v-icon>
            Currently Logged In {{getRoleDescription(item.roleId)}}
          </div>
          <div v-else>
            <v-icon class="mr-2">mdi-account</v-icon>
            {{getRoleDescription(item.roleId)}}
          </div>
        </div> 
      </template>
      <v-row style="gap: 6px;" class="no-gutters justify-space-between flex-nowrap pa-3">
        <v-col class="waybill-card-grid flex-nowrap ">
          
          <template v-for="(field, j) in headers">
                    <div
                    v-if="field.value != 'status'"
                      >
                      <div class="font-weight-medium text-caption text-uppercase mt-1">{{ field.text }}</div>
                      <div class="font-weight-regular text-subtitle-2 mt-1">
                        {{ item[field.value] }}
                      </div>
                    </div>
            </template>
            
        </v-col>
      </v-row>
    </v-card>
  </v-row>
  <v-pagination class="pagination mb-2 mt-6" v-model="pageNumber" :length="pages" @input="updatePage"></v-pagination>
  </v-container>

  </v-card>
</template>

<script>
import debounce from 'lodash.debounce';
export default {
  data() {
    return {
      excelClicked: false,
      printClicked: false,
      clearClicked: false,
      search: '',
      reloadText: 'Reload',
      listCount: 0,
      paginatedList: [],
      page: 1,
      pageNumber: 1,
      perPage: 12,
    }
  },
  props: ['items','headers','user','loading','hideAddButton','entity_name','title','show_excel','show_print','show_clear','showCardView'],
  computed: {
    pages() {
			let _this = this;
			if (_this.perPage == null || _this.listCount == null) return 0;
			return Math.ceil(_this.listCount / _this.perPage);
		}
  },
  created() {
    if (this.entity_name == 'user') {
      let _this = this;
      _this.initPage();
      _this.updatePage(_this.pageNumber);
    }
	},
  methods: {
    initPage: function () {
      if (this.items != undefined) {
        let _this = this;
        _this.listCount = _this.items.length;
        if (_this.listCount < _this.perPage) {
          _this.paginatedList = _this.items;
        } else {
          _this.paginatedList = _this.items.slice(0, _this.perPage);
        }
      }
    },
    updatePage: function (pageIndex) {
      if (this.items != undefined) {
        let _this = this;
        let _start = (pageIndex - 1) * _this.perPage;
        let _end = pageIndex * _this.perPage;
        _this.paginatedList = _this.items.slice(_start, _end);
        _this.pageNumber = pageIndex;
      }
    },
    getRoleDescription(role_id) {
      if(role_id===1){
        return "Admin";
      }else if(role_id===5){
        return "Freight Forwarder";
      }else {
        return "Client";
      } 
    },
    handleInput() {
      if (this.entity_name == 'user') {

        if (this.search == '') {
          this.initPage();
          this.updatePage(this.pageNumber);
        } else {
          this.debouncedSearchItems();
        }
      }

    },
    searchItems() {
        let finalSearch = this.search.toLowerCase().trim();
        this.paginatedList = this.items.filter(element => 
        (element.email != undefined && element.email.toLowerCase().includes(finalSearch)) || 
        (element.userFullName != undefined && element.userFullName.toLowerCase().includes(finalSearch)) || 
        (element.company != undefined && element.company.toLowerCase().includes(finalSearch)) || 
        (element.phone != undefined && element.phone.toLowerCase().includes(finalSearch)) || 
        (element.address != undefined && element.address.toLowerCase().includes(finalSearch))
        );
    },
    getFieldName(field) {
      return 'item.' + field.value;
    },
    ClearAllClicked(){ 
      this.clearClicked = true;
      this.$swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, clear all!'
        }).then((result) => {
            this.delete_click = false
            if (result.value) {
                this.clearAllEntities(this.entity_name, response=>{
                  this.getItems();
                  this.clearClicked = false;
                }) 
            }
        })
    },
      GenerateExcelFile() {
        this.excelClicked = true;
        const mimeType = 'data:application/vnd.ms-excel';
        const tbl = document.getElementById('table');
        const wrapper = tbl.querySelector('.v-data-table__wrapper');
        const clonedTable = wrapper.cloneNode(true);
        const documentPrefix = (this.title != undefined && this.title != '') ? this.title.replace(/ /g, '-') : this.entity_name;
        const d = new Date();
        const dummy = document.createElement('a');
        dummy.href = mimeType + ', ' + encodeURI(clonedTable.outerHTML);
        dummy.download = documentPrefix
          + '-' + d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate()
          + '-' + d.getHours() + '-' + d.getMinutes() + '-' + d.getSeconds()
          + '.xls';
        document.body.appendChild(dummy);
        dummy.click();
        document.body.removeChild(dummy);
        this.excelClicked = false;
      },
      GeneratePDFFile() { 
        this.printClicked = true;
        const tbl = document.getElementById('table');
        const wrapper = tbl.querySelector('.v-data-table__wrapper');
        var tds = wrapper.getElementsByTagName('td');
        var previousPadding = null;
        for (let t=0; t<tds.length; t++) {
          const cell = tds[t];
          if (cell.className != 'text-start') {
            continue;
          }
          cell.setAttribute('style', 'padding:0px !important');
        }
        const clonedTable = wrapper.cloneNode(true);
				this.synchronizeCssStyles(wrapper, clonedTable, true);
        clonedTable.setAttribute('style', 'overflow-x:visible;background-color:white;z-index:100000');
				clonedTable.style.position = 'absolute !important';
				clonedTable.style.width = window.outerWidth + 'px';
				clonedTable.style.height = '100%';
				clonedTable.style.boxShadow = '0px 0px 0px 1px rgba(0,0,0,0.2)';
				clonedTable.style.margin = '0px auto';
				clonedTable.style.top = 0;
				clonedTable.style.bottom = 0;
				clonedTable.style.left = 0;
				clonedTable.style.right = 0;
        clonedTable.id = 'clonedTable';
        document.body.insertBefore(clonedTable, document.body.firstChild);
        
        for (let v=0; v<tds.length; v++) {
          const cell = tds[v];
          if (cell.className != 'text-start') {
            continue;
          }
          cell.setAttribute('style', 'padding:0px 16px');
        }

				let win = window.open('', '');
				win.document.body.style.fontFamily = '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif';
				win.document.body.innerHTML = clonedTable.innerHTML;
				win.print();
				win.close();
        document.getElementById('clonedTable').remove();
        this.printClicked = false;
      },
      synchronizeCssStyles(src, destination, recursively) {
				destination.style.cssText = this.getComputedStyleCssText(src);
				if (recursively) {
					const vSrcElements = src.getElementsByTagName('*');
					const vDstElements = destination.getElementsByTagName('*');
					for (var i = vSrcElements.length; i--;) {
						const vSrcElement = vSrcElements[i];
						const vDstElement = vDstElements[i];
						vDstElement.style.cssText = this.getComputedStyleCssText(vSrcElement);
					}
				}
			},
			getComputedStyleCssText(element) {
				const cssObject = window.getComputedStyle(element);
				const cssAccumulator = [];
				if (cssObject.cssText !== ''){
					return cssObject.cssText;
				}
				for (let prop in cssObject){
					if (typeof cssObject[prop] === 'string'){
						cssAccumulator.push(prop + ' : ' + cssObject[prop]);
					}
				}
				return cssAccumulator.join('; ');
			}
  },
  mounted() {
    this.debouncedSearchItems = debounce(this.searchItems, 300); // Adjust the debounce delay as needed (in milliseconds)
  },
  watch: {
    loading(newValue) {
      this.reloadText = newValue ? 'Reloading...' : 'Reload'
    }
  }
}
</script>